import React, { useState } from "react";
import NavBar from "../../../Common/NavBar";
import LeftSideBar from "../Components/Sidebar";


const StudentLayout = ({ children, backgroundClass = "bg-slate-100" }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="max-md:w-screen">
      <NavBar />
      <div
        className={`relative grid items-start w-full min-h-screen pt-14 ${backgroundClass} max-md:block`}
        style={{
          gridTemplateColumns: "var(--student-sidebar-width, 4rem) 1fr",
          transition: "grid-template-columns 0.3s ease",
        }}
      >
        <LeftSideBar onSidebarToggle={setIsSidebarOpen} />
        
        {/* Enhanced blur overlay for mobile/tablet when sidebar is open */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 z-10 bg-black/30 backdrop-blur-lg md:hidden"
            style={{ top: '56px' }} // Below navbar
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
        
        <main
          className={`w-full min-h-screen ${backgroundClass} max-md:max-w-full max-md:pl-16`}
          style={{
            width: "100%",
            minWidth: 0,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default StudentLayout;
